const storeLookups = {
    namespaced: true,
    state: {
          lookups: {},
    },
    actions: {
        async load(context, lookupType) {
            if (loadingLookups[lookupType]) return;
            loadingLookups[lookupType] = true;
            if (context.state.lookups[lookupType]) return;
            var result = (await romeApi.get(`/config/enumoptions?name=${lookupType}`)).filter(e => isVisible(e));
            context.commit("setData", { lookupType: lookupType, values: result});
        },
    },
    mutations: {
        setData(state, data) {
            state.lookups[data.lookupType] = data.values;
            state.lookups = _.cloneDeep(state.lookups);
        },
    }
  };
  
  export default storeLookups;
  
  var loadingLookups = {};

  function isVisible(enumOption) {
    return !!enumOption.description;
  }


// WEBPACK FOOTER //
// ./src/framework/utils/x-lookups.js